<template>
  <v-autocomplete
    v-if="!$_.isEmpty(addreszerData)"
    :value="value"
    :items="addreszerData"
    :rules="rules"
    :menu-props="{
      maxHeight: 150,
      offsetY: true,
      offsetOverflow: true,
      transition: false
    }"
    item-value="district_code"
    item-text="text"
    placeholder="ตำบล/แขวง, อำเภอ/เขต, จังหวัด, รหัสไปรษณีย์"
    outlined
    dense
    @update:search-input="handleAutoComplete($event)"
    @input="$emit('input', $event)">
    <template #item="{ item }">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="secondary--text text-body"
        v-html="
          highlightText(
            `${item.district}, ${item.amphoe}, ${item.province}, ${item.zipcode}`
          )
        "></div>
      <!--eslint-enable-->
    </template>
  </v-autocomplete>
</template>

<script>
import zipcodeRawDatabase from '@/assets/js/addreszer/json/zipcode_raw_database.json'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      menu: false,
      searchText: '',
      addreszerData: []
    }
  },
  created () {
    this.addreszerData = zipcodeRawDatabase.data.map((data) => {
      const address = [data.district, data.amphoe, data.province, data.zipcode]
      return {
        ...data,
        text: this.$_.join(address, ', '),
        searchText: this.$_.join(address, '')
      }
    })
  },
  methods: {
    handleAutoComplete (value) {
      this.searchText = value
    },
    highlightText (str) {
      if (!this.searchText) return str
      return this.$_.replace(
        str,
        this.searchText,
        `<span class="primary--text">${this.searchText}</span>`
      )
    }
  }
}
</script>
